module.exports = __webpack_public_path__ + "img/labbanner2.feafa7ff.png";